import Api from '../../shared/Api';
import { CreateEditingStyleInput, EditingStyle, UpdateEditingStyleInput } from './types';

export class EditingStylesApi {
    static async getAllEditingStyles(): Promise<EditingStyle[]> {
        return new Api().get('/views/editing-styles');
    }

    static async createEditingStyle(input: CreateEditingStyleInput): Promise<EditingStyle> {
        return new Api().post('/views/editing-styles', input);
    }

    static async updateEditingStyle(id: number, input: UpdateEditingStyleInput): Promise<EditingStyle> {
        return new Api().put(`/views/editing-styles/${id}`, input);
    }
}
